import { apiGet } from 'utils/request';
import HOST from 'utils/globals';

export const fetchOrganizationUnit = id =>
  apiGet(`${HOST}/organizationUnits/${id}`);

export const fetchOrganizationUnits = () =>
  apiGet(`${HOST}/organizationUnits/hierarchy`);
